/**
 * Produces collision-free render identities without changing the semantic ids
 * exposed to callbacks and data attributes.
 */ export function createRenderIdentityPlan(ids, normalize = (id)=>id) {
    const normalizedIds = ids.map(normalize);
    const counts = new Map();
    for (const id of normalizedIds)counts.set(id, (counts.get(id) ?? 0) + 1);
    const duplicateIds = [
        ...new Set(ids.filter((_, index)=>(counts.get(normalizedIds[index]) ?? 0) > 1))
    ];
    const reserved = new Set(normalizedIds);
    const emitted = new Set();
    const identities = ids.map((id, index)=>{
        const normalizedId = normalizedIds[index];
        if ((counts.get(normalizedId) ?? 0) === 1 && !emitted.has(normalizedId)) {
            emitted.add(normalizedId);
            return id;
        }
        let candidate = `__specra_render_${index + 1}`;
        while(reserved.has(normalize(candidate)) || emitted.has(normalize(candidate))){
            candidate += '_';
        }
        emitted.add(normalize(candidate));
        return candidate;
    });
    return {
        duplicateIds,
        identities
    };
}
